<template>
  <li class="pr-3 pl-4" :class="isSubmenuList ? 'mb-0' : 'mb-1'">
    <component
      :is="componentIs"
      :to="itemTo"
      :href="itemHref"
      :target="itemTarget"
      v-slot="vSlot"
      :class="[isSubmenuList ? '' : '']"
      @click="menuClick"
    >
    <div :class="isSubmenuList ? 'border-l border-gray-400 dark:border-gray-600 transition-colors duration-1000 pl-1 pb-1' : ''">
      <div class="flex flex-nowrap gap-2 z-40 items-center cursor-pointer px-2 clear-left menu-list hover:text-black dark:hover:text-white" :class="vSlot && vSlot.isExactActive ? styleActive : styleInactive">
        <div class="side-icon">
          <icon
            :class="hasDropdown && isDropdownActive ? 'text-black dark:text-white' : ''"
            v-if="item.icon"
            :path="item.icon"
            :w="isSubmenuList ? 'w-5' : 'w-5'"
            :h="isSubmenuList ? 'h-5' : 'w-5'"
          />
        </div>

        <div class="side-label">
          <span :class="hasDropdown && isDropdownActive ? 'text-black dark:text-white' : ''">
            {{ $t(item.label) }}
          </span>
        </div>

        <div class="side-drop transition-transform duration-500" :class="isDropdownActive ? 'rot-side' : ''">
          <icon
            :class="hasDropdown && isDropdownActive ? 'text-black dark:text-white' : ''"
            v-if="hasDropdown"
            :path="mdiChevronRight"
            :w="'w-5'"
            :h="'h-5'"
          />
        </div>
      </div>
    </div>
    </component>

    <div class="menu-child" :class="isDropdownActive ? 'droping' : 'dropup'">
      <aside-menu-list
        v-if="hasDropdown"
        :menu="item.menu"
        is-submenu-list
      />
    </div>

    <!-- <hr v-if="isDropdownActive"> -->
  </li>
</template>

<script>
import { defineAsyncComponent, ref, computed } from 'vue'
import { mdiChevronRight } from '@mdi/js'
import Icon from '@/components/Icon'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'

export default {
  name: 'AsideMenuItem',
  components: {
    AsideMenuList: defineAsyncComponent(() => import('@/components/AsideMenuList')),
    Icon
  },
  emits: ['menu-click'],
  props: {
    item: Object,
    isSubmenuList: Boolean
  },
  setup (props, { emit }) {
    const { t } = useI18n()

    const store = useStore()

    const isDropdownActive = ref(false)

    const componentIs = computed(() => props.item.to ? 'router-link' : 'a')

    const hasDropdown = computed(() => !!props.item.menu)

    // const dropdownIcon = computed(() => isDropdownActive.value ? mdiMinus : mdiPlus)

    const itemTo = computed(() => props.item.to || null)

    const itemHref = computed(() => props.item.href || null)

    const itemTarget = computed(() => componentIs.value === 'a' && props.item.target ? props.item.target : null)

    const menuClick = event => {
      emit('menu-click', event, props.item)

      if (hasDropdown.value) {
        isDropdownActive.value = !isDropdownActive.value
      }
    }

    const darkMode = computed(() => store.state.darkMode)

    const styleActive = 'sidebar-active'

    const styleInactive = 'text-gray-400 dark:text-gray-500 py-2'

    return {
      t,
      darkMode,
      isDropdownActive,
      componentIs,
      hasDropdown,
      // dropdownIcon,
      mdiChevronRight,
      itemTo,
      itemHref,
      itemTarget,
      menuClick,
      styleActive,
      styleInactive
    }
  }
}
</script>
